import type { UserProfileItem } from '@cognite/sdk';

export const isServicePrincipal = (
  userProfile?: UserProfileItem | undefined
) => {
  if (!userProfile) {
    return false;
  }
  return userProfile.identityType === 'SERVICE_PRINCIPAL';
};

const getGivenNameAndSurname = (userProfile?: UserProfileItem) => {
  if (!userProfile || !userProfile.givenName || !userProfile.surname) {
    return undefined;
  }
  return `${userProfile?.givenName} ${userProfile?.surname}`;
};

export const getUserName = (userProfile?: UserProfileItem) => {
  const givenNameAndSurname = getGivenNameAndSurname(userProfile);
  return (
    givenNameAndSurname ||
    userProfile?.displayName ||
    userProfile?.email ||
    userProfile?.userIdentifier
  );
};
